/**
 * JS mirror of Ppk2\Profile\Rules\LoginRules and PasswordRules (src/Rules) for instant
 * feedback. Keep both in sync. The server always re-checks.
 */
export const LOGIN_KEY = 'ppk2-profile.lib.rules.login.';
export const PASSWORD_KEY = 'ppk2-profile.lib.rules.password.';
export const LOGIN_MIN = 3;
export const LOGIN_MAX = 30;
export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 128;
const SPECIAL = "_!@#$%^&*()\\-+=.,?:;~\\[\\]{}\\/\\\\|'\"<>";
const PASSWORD_CHAR = new RegExp('^[A-Za-z0-9' + SPECIAL + ']$');
const SPECIAL_CHAR = new RegExp('[' + SPECIAL + ']');
function displayChar(ch) {
  if (/^[\s\p{Z}\p{C}]$/u.test(ch)) return 'U+' + ch.codePointAt(0).toString(16).toUpperCase().padStart(4, '0');
  return ch;
}

/** @returns {[string, object] | null} [translation key, params] of the first problem */
export function checkLogin(login) {
  if (!login) return [LOGIN_KEY + 'required', {}];
  const chars = Array.from(login);
  for (const ch of chars) if (!/^[A-Za-z0-9_]$/.test(ch)) return [LOGIN_KEY + 'invalid_char', {
    char: displayChar(ch)
  }];
  if (chars.length < LOGIN_MIN) return [LOGIN_KEY + 'too_short', {
    min: LOGIN_MIN
  }];
  if (chars.length > LOGIN_MAX) return [LOGIN_KEY + 'too_long', {
    max: LOGIN_MAX
  }];
  return null;
}

/** @returns {[string, object] | null} */
export function checkPassword(password) {
  if (!password) return [PASSWORD_KEY + 'required', {}];
  const chars = Array.from(password);
  for (const ch of chars) {
    if (!PASSWORD_CHAR.test(ch)) return [PASSWORD_KEY + (ch === ' ' ? 'space' : 'invalid_char'), {
      char: displayChar(ch)
    }];
  }
  if (chars.length < PASSWORD_MIN) return [PASSWORD_KEY + 'too_short', {
    min: PASSWORD_MIN
  }];
  if (chars.length > PASSWORD_MAX) return [PASSWORD_KEY + 'too_long', {
    max: PASSWORD_MAX
  }];
  if (!/[A-Z]/.test(password)) return [PASSWORD_KEY + 'need_upper', {}];
  if (!/[a-z]/.test(password)) return [PASSWORD_KEY + 'need_lower', {}];
  if (!/[0-9]/.test(password)) return [PASSWORD_KEY + 'need_digit', {}];
  if (!SPECIAL_CHAR.test(password)) return [PASSWORD_KEY + 'need_special', {}];
  return null;
}

/**
 * Email format for instant feedback (the server checks with its own validator):
 * one «@», something before it, a dot in the domain, no spaces.
 */
export function isEmail(email) {
  return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(String(email || '').trim()) && String(email).trim().length <= 150;
}
flarum.reg.add('ppk2-profile', 'common/accountRules', { LOGIN_KEY: LOGIN_KEY,PASSWORD_KEY: PASSWORD_KEY,LOGIN_MIN: LOGIN_MIN,LOGIN_MAX: LOGIN_MAX,PASSWORD_MIN: PASSWORD_MIN,PASSWORD_MAX: PASSWORD_MAX,checkLogin: checkLogin,checkPassword: checkPassword,isEmail: isEmail, });